import { Helmet } from "react-helmet";
import "./furnaces.scss";
// import { Link } from "react-router-dom";

export default function Furnaces() {

    // const scrollToTop = () => {
    //     window.scrollTo(0, 0)
    // }
  return (
    <div className="furnace">
      <Helmet>
        <title>Furnaces || Raydron, Lagos, Nigeria</title>
        <meta name="description" content="At Raydron we specialize in building furnaces such as tilting furnace, rotary furnace, walking beam furnace, induction furnace, and many more"/>
        <meta name="keywords" content="Aluminium Smelting Furnace, Cast Iron Furnace, Induction Furnace, Rotary Furnace, Tunnel Furnace, Walking Beam Furnace" />
      </Helmet>
        <div className="intro">
            We build various categories of furnaces in our yard. Choose the type you need from the list below or contact us for custom requirements.
        </div>
        <div className="workflow__wrapper">
          <div className="workflow">
            <div className="explain">
              <h2 className="title">Tilting Furnace</h2>
              <p className="text">We manufacture tilting furnaces with capacities ranging from 50kg to 2,000Kg for melting aluminium, copper, bronze, brass, lead and other non-ferrous alloys. The heat source fuel can be either gas or light oil like diesel or heavy oils like waste engine oil.</p>
            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1730898130/300kg_furnace_3_qms8mm.jpg" alt="raydron_workflow" className="workflow__img" />
              <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAPM">Chat Us to Order</button></a>
            </div>
          </div>
          <div className="workflow">
            <div className="explain">
              <h2 className="title">Induction Furnace</h2>
              <p className="text">We manufacture state-of-the-art induction furnace for melting cast iron, steel, aluminium, copper, gold and other non-ferrous alloys. The capacities of our induction furnace range from 10kg to 150tons. Our induction furnaces comes complete with with the power supply cabinet, hyrdualic power pack, cooling heat exchanger system, and furnace crucible form. We can also supply the ramming mass required to form the crucible.</p>

            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1730899578/induction_furnace_sample_p4eg6v.jpg" alt="raydron_workflow" className="workflow__img" />
              <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAPM">Chat Us to Order</button></a>
            </div>
          </div>
       
          <div className="workflow">
            <div className="explain">
              <h2 className="title">Rotary Furnace</h2>
              <p className="text">Our Rotary furnaces range from 500kg to 5 tons. The rotary furnace can be designed for use in melting lead, copper and cast iron. It comes with the variable frequency driving unit for the motor control.</p>

            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1730879424/rotary_furnace_jbnbgk.png" alt="raydron_workflow" className="workflow__img" />
              <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAPM">Chat Us to Order</button></a>
            </div>
          </div>

        </div>
    </div>
  )
}
